import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../constants';
import { useAuth } from '../useAuth';
import dashboardController, {
  SalesDashboardOrganization,
} from '../../services/api/dashboardController';

type AuthLike = { tokens?: { idToken?: { jwtToken?: string } } };

export const useSalesOrganizations = () => {
  const auth = useAuth();
  const authToken = (auth as AuthLike)?.tokens?.idToken?.jwtToken ?? '';

  return useQuery<SalesDashboardOrganization[]>({
    queryKey: QUERY_KEYS.SALES_ORGANIZATIONS,
    queryFn: async () => {
      const response =
        await dashboardController.getSalesOrganizations(authToken);
      return response?.data?.organizations || [];
    },
    enabled: Boolean(authToken),
  });
};
